import React from 'react';

const RadioOption = ({ checked, onChange, label, description, className }) => {
    return (
        <label className={`flex ${className}`}>
            <input
                type="radio"
                className="mt-4"
                checked={checked}
                onChange={e => e.target.checked && onChange(true)}
            />
            <div className="flex-1 py-3 ml-3 pr-3">
                {label}
                {description && (
                    <div className="text-sm text-gray-500">{description}</div>
                )}
            </div>
        </label>
    );
};

export default RadioOption;
